import { render, staticRenderFns } from "./ProfileAboutBlocks.vue?vue&type=template&id=1e53e363&scoped=true&"
import script from "./ProfileAboutBlocks.vue?vue&type=script&lang=js&"
export * from "./ProfileAboutBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53e363",
  null
  
)

export default component.exports